import { render, staticRenderFns } from "./CadriPage.vue?vue&type=template&id=620365a7&scoped=true"
import script from "./CadriPage.vue?vue&type=script&lang=js"
export * from "./CadriPage.vue?vue&type=script&lang=js"
import style0 from "./CadriPage.vue?vue&type=style&index=0&id=620365a7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620365a7",
  null
  
)

export default component.exports